import { Card, Heading, Stack } from '@etg/wings';
import { useProperty, useTranslation } from '@eti/providers';

const AgencyFAQ = () => {
  const { p } = useProperty();
  const { t } = useTranslation();

  const agencyFAQUrl = p('OrderDetails.Agency.FAQ.Url');

  return (
    <Card data-testid="agency-faq-card">
      <Stack>
        <Heading data-testid="agency-faq-title" level={2}>
          {t('OrderDetails.Agency.FAQ.Title')}
        </Heading>
        <a data-testid="agency-faq-link" href={agencyFAQUrl} rel="noreferrer" target="_blank">
          {t('OrderDetails.Agency.FAQ.Link.Text')}
        </a>
      </Stack>
    </Card>
  );
};

export default AgencyFAQ;
